export default function CtaBanner() {
  return (
    <section className="w-full py-16 md:py-24 bg-background-100">
      <div className="w-full px-4 md:px-8">
        <div className="max-w-6xl mx-auto relative rounded-2xl overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=abstract%20dark%20cinematic%20banner%20with%20warm%20amber%20and%20deep%20red%20gradient%20light%2C%20subtle%20film%20strip%20texture%2C%20soft%20glow%20and%20floating%20dust%20particles%2C%20minimal%20elegant%20movie%20theme%2C%20no%20text%2C%20high%20detail&width=1920&height=640&seq=starfilm-cta-2026&orientation=landscape"
            alt="星辰影视下载引导背景"
            className="absolute inset-0 w-full h-full object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/50 to-black/60"></div>

          <div className="relative z-10 px-6 md:px-14 py-12 md:py-16 flex flex-col lg:flex-row lg:items-center lg:justify-between gap-8">
            <div className="max-w-2xl">
              <h2 className="font-heading text-2xl md:text-4xl font-bold text-background-50 leading-snug">
                现在就获取星辰影视最新安装包
              </h2>
              <p className="mt-4 text-sm md:text-base text-background-100/90 leading-relaxed">
                手机版与 TV 版安装包均在本页提供下载入口，跟着分区步骤操作，
                几分钟即可完成安装，畅享稳定流畅的影视播放体验。
              </p>
            </div>
            <div className="flex flex-col sm:flex-row lg:flex-col gap-3 shrink-0">
              <a
                href="#mobile"
                className="inline-flex items-center justify-center gap-2 bg-primary-500 text-background-50 text-sm px-6 py-3 rounded-md cursor-pointer whitespace-nowrap hover:bg-primary-600 transition-colors"
              >
                <i className="ri-smartphone-line"></i>
                下载手机版客户端
              </a>
              <a
                href="#tv"
                className="inline-flex items-center justify-center gap-2 bg-background-50 text-foreground-950 text-sm px-6 py-3 rounded-md cursor-pointer whitespace-nowrap hover:bg-background-100 transition-colors"
              >
                <i className="ri-tv-2-line"></i>
                下载 TV 版安装包
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}